import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,ViewController} from 'ionic-angular';

/**
 * Generated class for the AvailabilityPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-availability',
  templateUrl: 'availability.html',
})
export class AvailabilityPage {
  // choose:any={};
  item:any={};
  

  constructor(public navCtrl: NavController, public navParams: NavParams,public viewCtrl: ViewController) {
    this.item = navParams.get('item')
    // this.item.times = new Date()
    this.item.slot = "default";
    // this.item.time = new Date()
    console.log(this.item)

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AvailabilityPage');
  }
  dismiss() {
    this.viewCtrl.dismiss();
  }
savechanges(){
// 2019-10-16T07:10:20Z
// console.log(this.item.times)
if(this.item.times != undefined){
  var s=this.item.times.replace('T',' ')
  console.log(s)
  s= s.replace('Z','')
  this.item.times = s;
}
  console.log(s)
  // split('=').join(', ').split(':').join(', ').split(', '); 
  // var s=this.item.times.split('T').join(',').split('z')
// console.log(s)
  // this.formatAMPM(this.item.times)
  this.viewCtrl.dismiss(this.item);
}
// formatAMPM(date) {
//   var hours = date.getHours()
//   var minutes = date.getMinutes()
//   var ampm = hours >= 12 ? 'pm' : 'am';
//   hours = hours % 12;
//   hours = hours ? hours : 12; // the hour '0' should be '12'
//   var minutes = minutes < 10 ? '0' + minutes : minutes;
//   var strTime = hours + ':' + minutes + ' ' + ampm;
//   this.times = strTime
//   console.log(this.times)
// }


}



// WEBPACK FOOTER //
// ./src/pages/availability/availability.ts